// Constants
import TRACKER_CONSTANTS from '@/constants/TRACKER_CONSTANTS'

const mixin = {
  props: {
    statusLevel: {
      type: Number,
      required: true,
      default: 1
    },
    progressColor: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    TRACKER_CONSTANTS
  }),
  methods: {
    getStatusBarClass: function(positionLevel) {
      let statusBarClass = this.STATUS_BAR_CLASSES.DISABLED
      if ((this.statusLevel === positionLevel) && (positionLevel !== TRACKER_CONSTANTS.ORDER_STATUS_BAR_STEPS)) {
        statusBarClass = this.STATUS_BAR_CLASSES.ACTIVE
      } else if (this.statusLevel >= positionLevel) {
        statusBarClass = this.STATUS_BAR_CLASSES.COMPLETED
      }
      return statusBarClass
    }
  }
}

export default mixin
